// Module
var code = "<div class=\"embed-spinner\" data-us-spinner data-spinner-key=\"spinner\"></div> <ui-v2-embed class=\"embed-page\" src=\"{{pathtreeSrc}}\" on-load=\"onLoad()\"></ui-v2-embed> ";
// Exports
export default code;